import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BackdropModule } from '../../@prep/shared/backdrop/backdrop.module';
import { LoadingIndicatorModule } from '../../@prep/shared/loading-indicator/loading-indicator.module';
import { MaterialModule } from '../../@prep/shared/material-components.module';
import { FooterModule } from './footer/footer.module';
import { LayoutComponent } from './layout.component';
import { SidenavModule } from './sidenav/sidenav.module';
import { ToolbarModule } from './toolbar/toolbar.module';
import { ConfigPanelModule } from './config-panel/config-panel.module';
import { PrepSharedModule } from '../../@prep/prep-shared.module';
import { NavigationModule } from './navigation/navigation.module';
import { PrepTourModule } from '../../@prep/shared/tour';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    LoadingIndicatorModule,
    PrepSharedModule,

    // Core
    ToolbarModule,
    SidenavModule,
    FooterModule,
    BackdropModule,
    ConfigPanelModule,
    NavigationModule,
    PrepTourModule
  ],
  declarations: [LayoutComponent]
})
export class LayoutModule {
}
